import {
  Badge,
  Button,
  Card,
  Col,
  Input,
  Progress,
  Row,
  Select,
  Tag,
} from "antd";
import {
  DownloadIcon,
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../../atoms/CustomIcons";

export default function Dashboard() {
  return (
    <div className="profileWrapper">
      <Card className="profileDashboardCard">
        <div className="profileTitle">
          <h3>Stats</h3>
          <div>
            <Select
              suffixIcon={<SelectArrow />}
              menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
              showSearch
              allowClear
              placeholder="Filters"
              defaultValue="Filters"
              popupMatchSelectWidth={false}
              options={[
                {
                  value: "past_month",
                  label: "Past month",
                },
                {
                  value: "past_6_months",
                  label: "Past 6 months",
                },
                {
                  value: "past_quarter",
                  label: "Past quarter",
                },
                {
                  value: "past_year",
                  label: "Past year",
                },
              ]}
            />
          </div>
        </div>
        <Row gutter={[8, 8]}>
          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Total revenue</div>
                <div className="info">$5,067</div>
              </div>
              <Progress
                percent={100}
                success={{ percent: 80, strokeColor: "#6454F4" }}
                showInfo={false}
                type="line"
                strokeColor="#44A6F1"
                size={["100%", 12]}
              />
              <div className="progressInfo">
                <div className="infoWrapper">
                  <Badge color="#6454F4" text="Landscape maintenance" />
                  <div className="infoValue">$3,000</div>
                </div>
                <div className="infoWrapper">
                  <Badge color="#44A6F1" text="Enhancements" />
                  <div className="infoValue">$2,067</div>
                </div>
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card className="progressCard">
              <div className="profileProgressHeader">
                <div className="label">Gross margin</div>
                <div className="info">30%</div>
              </div>
              <Progress
                percent={100}
                success={{ percent: 80, strokeColor: "#6454F4" }}
                showInfo={false}
                type="line"
                strokeColor="#44A6F1"
                size={["100%", 12]}
              />
              <div className="progressInfo">
                <div className="infoWrapper">
                  <Badge color="#6454F4" text="Sub cost" />
                  <div className="infoValue">3,547</div>
                </div>
                <div className="infoWrapper">
                  <Badge color="#44A6F1" text="Earned revenue" />
                  <div className="infoValue">$5,067</div>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Card>

      <Card className="profileDashboardCard">
        <div className="profileTitle">
          <h3>Contracts</h3>
        </div>

        <Card style={{ borderRadius: "16px" }}>
          <Row gutter={[0, 4]}>
            <Col span={24}>
              <div className="filtersWrapper" style={{ marginBottom: "12px" }}>
                <div
                  className="filtersTop"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="filterSearch">
                    <Input
                      prefix={<SearchIcon />}
                      placeholder="Search contracts"
                      allowClear
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div className="filterToggle">
                      <Button
                        icon={<FilterIcon />}
                        className="outlined-btn"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Filters
                        <div className="filter_icon">
                          <SelectArrow />
                        </div>
                      </Button>
                    </div>
                    <div className="filterDownload">
                      <Button
                        icon={<DownloadIcon />}
                        style={{ height: "36px", width: "36px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <Card className="contactCard crewsContactCard">
                <div className="contactCardLeft">
                  <div className="namePosition">
                    <Tag style={{ marginBottom: "16px" }}>
                      Golden Valley Estates
                    </Tag>
                    <h4>Maintenance Agreement 71567</h4>
                    <p style={{ fontSize: "14px", marginBottom: "16px" }}>
                      May 24, 2025 - May 24, 2026
                    </p>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <Tag className="default_tag mint_tag">
                        Landscape maintenance
                      </Tag>
                      <Tag className="default_tag purple_tag">Lawn care</Tag>
                    </div>
                  </div>

                  <div className="infoText">
                    <div className="labelText">Account manager</div>
                    <div className="valueText">
                      <img
                        src="/images/dummy/manager.png"
                        alt=""
                        style={{ width: "20px" }}
                      />
                      Andrew O.
                    </div>
                  </div>

                  <div className="infoText">
                    <div className="labelText">Product manager</div>
                    <div className="valueText">
                      <img
                        src="/images/dummy/manager.png"
                        alt=""
                        style={{ width: "20px" }}
                      />
                      Brad T.
                    </div>
                  </div>

                  <div className="infoText">
                    <Card className="dealsInnerCardItem greenCard">
                      <div
                        className="innerLabel"
                        style={{ marginBottom: "12px" }}
                      >
                        Status
                      </div>
                      <Tag
                        className="default_tag accepted_tag"
                        style={{ color: "#fff" }}
                      >
                        Active
                      </Tag>
                      <img
                        src="/images/grey_filled_success.svg"
                        alt=""
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "12px",
                        }}
                      />
                    </Card>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Card>
      </Card>
    </div>
  );
}
